export default __webpack_public_path__ + "static/media/IconJpg.5bc94048.svg";